import documentTypesData from '../config/documentTypesData';
import moment from 'moment';
import { get } from 'lodash';
import { searchSuggestionTypeConfig } from '../config/appConfig';
export const SET_SELECTED_DOCUMENT_TYPES = 'TOPIC/SET_SELECTED_DOCUMENT_TYPES';
export const SET_SEARCH_TEXT = 'TOPIC/SET_SEARCH_TEXT';
export const SET_DATE_RANGE = 'TOPIC/SET_DATE_RANGE';
export const SET_SEARCH_RESULT = 'TOPIC/SET_SEARCH_RESULT';
export const SET_SEARCH_RESULT_HIGHLIGHTS = 'TOPIC/SET_SEARCH_RESULT_HIGHLIGHTS';
export const SET_SUGGESTIONS_RESULT = 'TOPIC/SET_SUGGESTIONS_RESULT';
export const SET_SUGGESTIONS_RESULT_AND_SELECTIONS = 'TOPIC/SET_SUGGESTIONS_RESULT_AND_SELECTIONS';
export const SET_SELECTED_SUGGESTIONS = 'TOPIC/SET_SELECTED_SUGGESTIONS';
export const SET_ALL_SEARCH_PARAMS = 'TOPIC/SET_ALL_SEARCH_PARAMS';
export const SET_SELECTED_SEARCH = 'TOPIC/SET_SELECTED_SEARCH';
export const RESET_SUGGESTIONS = 'TOPIC/RESET_SUGGESTIONS';
export const SET_SUGGESTIONS_IS_LOADING = 'TOPIC/SET_SUGGESTIONS_IS_LOADING';
export const SET_SHOW_BACKDROP = 'TOPIC/SET_SHOW_BACKDROP';
export const RESET_SEARCH_RESULTS = 'TOPIC/RESET_SEARCH_RESULTS';
export const RESET_ALL_SEARCH_PARAMS = 'TOPIC/RESET_ALL_SEARCH_PARAMS';
export const SET_SELECTED_COMPANY_NAME = 'TOPIC/SET_SELECTED_COMPANY_NAME';
export const SET_SELECTED_UNIVERSE = 'TOPIC/SET_SELECTED_UNIVERSE';
export const SET_SELECTED_SECTOR = 'TOPIC/SET_SELECTED_SECTOR';
export const SET_SELECTED_WATCHLIST_CATEGORY = 'TOPIC/SET_SELECTED_WATCHLIST_CATEGORY';
export const SET_SELECTED_INDUSTRIES = 'TOPIC/SET_SELECTED_INDUSTRIES';
export const SET_SELECTED_WATCHLIST_COMPANY_NAMES = 'TOPIC/SET_SELECTED_WATCHLIST_COMPANY_NAMES';
export const SET_SAVED_SEARCHES = 'TOPIC/SET_SAVED_SEARCHES';
export const SET_SEARCH_LABEL = 'TOPIC/SET_SEARCHE_LABEL';
export const SET_OPEN_TOPIC_SEARCH_DIALOG = 'TOPIC/SET_OPEN_TOPIC_SEARCH_DIALOG';
export const SET_CURRENT_SEARCH_DETAIL = 'TOPIC/SET_CURRENT_SEARCH_DETAIL';
export const SET_IS_TOPIC_EMAIL_ALERT_ENABLE = 'TOPIC/SET_IS_TOPIC_EMAIL_ALERT_ENABLE';
export const SET_IS_SIMPLE_SEARCH = 'TOPIC/SET_IS_SIMPLE_SEARCH';
export const SET_SIMPLE_SEARCH_TEXT_ARRAY = 'TOPIC/SET_SIMPLE_SEARCH_TEXT_ARRAY';
export const SET_IGNORE_SEARCH_TEXT_ARRAY = 'TOPIC/SET_IGNORE_SEARCH_TEXT_ARRAY';
export const SET_SEARCH_TEXT_WITH_AND = 'TOPIC/SET_SEARCH_TEXT_WITH_AND';
export const SET_SEARCH_INDEX = 'TOPIC/SET_SEARCH_INDEX';
export const SET_TWEETS_DATA = 'TOPIC/SET_TWEETS_DATA';
export const SET_TWEETS_COUNTRY_MAP_DATA = 'TOPIC/SET_TWEETS_COUNTRY_MAP_DATA';
export const SET_TWEETS_TABLE_DATA = 'TOPIC/SET_TWEETS_TABLE_DATA';
export const SET_SELECTED_COUNTRY = 'TOPIC/SET_SELECTED_COUNTRY';
export const SET_TOPIC_SEARCH_COMPANY = 'TOPIC/SET_TOPIC_SEARCH_COMPANY';
export const SET_SEARCH_SUGGESTION_TYPE = 'TOPIC/SET_SEARCH_SUGGESTION_TYPE';
export const SET_TWITTER_DATA = 'TOPIC/SET_TWITTER_DATA';
export const SET_TWITTER_MAP_DATA = 'TOPIC/SET_TWITTER_MAP_DATA';
export const SET_TWITTER_GEO_LOCATION_ENABLE = 'TOPIC/SET_TWITTER_GEO_LOCATION_ENABLE';
export const SET_TWITTER_TIMELINE_CHART_DATA = 'TOPIC/SET_TWITTER_TIMELINE_CHART_DATA';
export const SET_TWITTER_ENTITY_CHART_DATA = 'TOPIC/SET_TWITTER_ENTITY_CHART_DATA';
export const SET_TWITTER_TOP_ENTITY_CONTEXT = 'TOPIC/SET_TWITTER_TOP_ENTITY_CONTEXT';

export const setShowBackdrop = showBackdrop => ({
  type: SET_SHOW_BACKDROP,
  showBackdrop,
});

export const resetResultsPage = () => ({
  type: RESET_SEARCH_RESULTS,
});

export const setSuggestionsIsLoading = suggestionsIsLoading => ({
  type: SET_SUGGESTIONS_IS_LOADING,
  suggestionsIsLoading,
});

export const setSelectedSearch = selectedSearch => ({
  type: SET_SELECTED_SEARCH,
  selectedSearch,
});

export const setSelectedDocumentTypes = selectedDocumentTypes => ({
  type: SET_SELECTED_DOCUMENT_TYPES,
  selectedDocumentTypes,
});

export const setTopicSearchText = text => ({
  type: SET_SEARCH_TEXT,
  text,
});

export const setTopicSearchDateRange = dateRangeObj => ({
  type: SET_DATE_RANGE,
  dateRangeObj,
});

export const setSearchResults = searchResult => ({
  type: SET_SEARCH_RESULT,
  searchResult,
});

export const setSuggestions = suggestions => ({
  type: SET_SUGGESTIONS_RESULT,
  suggestions,
});

export const setSuggestionsWithSelections = (suggestions, selectedSuggestions) => ({
  type: SET_SUGGESTIONS_RESULT_AND_SELECTIONS,
  data: { suggestions, selectedSuggestions },
});

export const setSelectedSuggestions = selectedSuggestions => ({
  type: SET_SELECTED_SUGGESTIONS,
  selectedSuggestions,
});

export const setAllSearchParams = searchObj => ({
  type: SET_ALL_SEARCH_PARAMS,
  searchObj,
});

export const resetSuggestions = () => ({
  type: RESET_SUGGESTIONS,
});

export const setSearchResultHighlights = searchResultHighlights => ({
  type: SET_SEARCH_RESULT_HIGHLIGHTS,
  searchResultHighlights,
});

export const resetAllSearchParams = () => ({
  type: RESET_ALL_SEARCH_PARAMS,
});

export const setSelectedCompanyName = selectedCompanyName => ({
  type: SET_SELECTED_COMPANY_NAME,
  selectedCompanyName,
});

export const setSelectedUniverse = selectedUniverse => ({
  type: SET_SELECTED_UNIVERSE,
  selectedUniverse,
});

export const setSelectedSector = selectedSector => ({
  type: SET_SELECTED_SECTOR,
  selectedSector,
});

export const setSelectedWatchlistCategory = selectedWatchlistCategory => ({
  type: SET_SELECTED_WATCHLIST_CATEGORY,
  selectedWatchlistCategory,
});

export const setSelectedIndustries = selectedIndustries => ({
  type: SET_SELECTED_INDUSTRIES,
  selectedIndustries,
});

export const setSelectedWatchlistCompanyNames = selectedWatchlistCompanyNames => ({
  type: SET_SELECTED_WATCHLIST_COMPANY_NAMES,
  selectedWatchlistCompanyNames,
});

export const setSavedSearches = savedSearches => ({
  type: SET_SAVED_SEARCHES,
  savedSearches,
});

export const setSearchLabel = searchLabel => ({
  type: SET_SEARCH_LABEL,
  searchLabel,
});

export const setOpenTopicSearchDialog = openTopicSearchDialog => ({
  type: SET_OPEN_TOPIC_SEARCH_DIALOG,
  openTopicSearchDialog,
});

export const setCurrentSearchtDetail = currentSearchDetail => ({
  type: SET_CURRENT_SEARCH_DETAIL,
  currentSearchDetail,
});

export const setIsTopicEmailAlertEnable = isTopicEmailAlertEnable => ({
  type: SET_IS_TOPIC_EMAIL_ALERT_ENABLE,
  isTopicEmailAlertEnable,
});
export const setIsSimpleSearch = isSimpleSearch => ({
  type: SET_IS_SIMPLE_SEARCH,
  isSimpleSearch,
});

export const setSimpleSearchTextArray = simpleSearchTextArray => ({
  type: SET_SIMPLE_SEARCH_TEXT_ARRAY,
  simpleSearchTextArray,
});

export const setIgnoreSearchTextArray = ignoreSearchTextArray => ({
  type: SET_IGNORE_SEARCH_TEXT_ARRAY,
  ignoreSearchTextArray,
});

export const setSearchTextWithAnd = searchTextWithAnd => ({
  type: SET_SEARCH_TEXT_WITH_AND,
  searchTextWithAnd,
});

export const setSearchIndex = searchIndex => ({
  type: SET_SEARCH_INDEX,
  searchIndex,
});
export const setTweetsData = tweetsData => ({
  type: SET_TWEETS_DATA,
  tweetsData,
});

export const setTweetsCountryMapData = tweetsCountryMapData => ({
  type: SET_TWEETS_COUNTRY_MAP_DATA,
  tweetsCountryMapData,
});

export const setTweetsTableData = tweetsTableData => ({
  type: SET_TWEETS_TABLE_DATA,
  tweetsTableData,
});

export const setSelectedCountry = selectedCountry => ({
  type: SET_SELECTED_COUNTRY,
  selectedCountry,
});

export const setTopicSearchCompany = topicSearchedComapny => ({
  type: SET_TOPIC_SEARCH_COMPANY,
  topicSearchedComapny,
});

export const setSearchSuggestionType = searchSuggestionType => ({
  type: SET_SEARCH_SUGGESTION_TYPE,
  searchSuggestionType,
});

export const setTwitterData = twitterData => ({
  type: SET_TWITTER_DATA,
  twitterData,
});

export const setTwitterMapData = twitterMapData => ({
  type: SET_TWITTER_MAP_DATA,
  twitterMapData,
});

export const setTwitterGeoLocationEnable = twitterGeoLocationEnable => ({
  type: SET_TWITTER_GEO_LOCATION_ENABLE,
  twitterGeoLocationEnable,
});

export const setTwitterTimelineChartData = twitterTimelineChartData => ({
  type: SET_TWITTER_TIMELINE_CHART_DATA,
  twitterTimelineChartData,
});

export const setTwitterTopEntityGridData = twitterTopEntityGridData => ({
  type: SET_TWITTER_ENTITY_CHART_DATA,
  twitterTopEntityGridData,
});

export const setTwitterTopEntityContext = twitterTopEntityContext => ({
  type: SET_TWITTER_TOP_ENTITY_CONTEXT,
  twitterTopEntityContext,
});

const searchDefaultState = () => ({
  searchText: '',
  tweetsCountryMapData: {},
  tweetsData: null,
  // searchIndex: null,
  startDate: moment()
    .startOf('month')
    .subtract(12, 'months'),
  endDate: moment().endOf('month'),
  selectedSuggestions: {},
  tweetsTableData: [],
  selectedDocumentTypes: documentTypesData.map(docType => docType.documentTypeGroup),
  twitterData: null,
  twitterMapData: [],
  twitterTimelineChartData: null,
  twitterTopEntityGridData: null,
  twitterTopEntityContext: '',
  twitterGeoLocationEnable: false,
  selectedUniverse: 'all',
  selectedSector: null,
  selectedWatchlistCategory: null,
  selectedIndustries: [],
  selectedWatchlistCompanyNames: [],
  isTopicEmailAlertEnable: true,
  searchLabel: '',
  isSimpleSearch: true,
  simpleSearchTextArray: [],
  ignoreSearchTextArray: [],
  searchTextWithAnd: [],
  selectedCountry: null,
});

const getDefaultState = () => {
  return {
    ...searchDefaultState(),
    searchIndex: null,
    documentTypes: documentTypesData,
    suggestions: {},
    searchResult: {},
    selectedSearch: null,
    suggestionsIsLoading: false,
    showBackdrop: 0,
    searchResultHighlights: null,
    selectedCompanyName: null,
    savedSearches: null,
    openTopicSearchDialog: true,
    currentSearchDetail: {},
    topicSearchedComapny: '',
    searchSuggestionType: searchSuggestionTypeConfig.simpleSearchTextArray,
  };
};

export default function reducer(
  state = {
    ...getDefaultState(),
  },
  action
) {
  switch (action.type) {
    case SET_SELECTED_DOCUMENT_TYPES:
      return { ...state, selectedDocumentTypes: action.selectedDocumentTypes };
    case SET_SEARCH_TEXT:
      return { ...state, searchText: action.text };
    case SET_DATE_RANGE:
      return { ...state, startDate: action.dateRangeObj.startDate, endDate: action.dateRangeObj.endDate };
    case SET_SEARCH_RESULT:
      return { ...state, searchResult: action.searchResult };
    case SET_SUGGESTIONS_RESULT:
      return { ...state, suggestions: action.suggestions };
    case SET_SUGGESTIONS_RESULT_AND_SELECTIONS:
      return { ...state, suggestions: action.data.suggestions, selectedSuggestions: action.data.selectedSuggestions };
    case SET_SELECTED_SUGGESTIONS:
      return { ...state, selectedSuggestions: action.selectedSuggestions };
    case SET_ALL_SEARCH_PARAMS:
      return {
        ...state,
        isTopicEmailAlertEnable: action.searchObj.send_topic_alert_email,
        searchText: action.searchObj.searchText ?? '',
        searchLabel: action.searchObj.searchLabel,
        selectedDocumentTypes: action.searchObj.searchJSON.selectedDocumentTypes,
        selectedSuggestions: action.searchObj.searchJSON.selectedSuggestions,
        searchIndex: action.searchObj.searchJSON.searchIndex,
        selectedUniverse: get(action.searchObj, 'searchJSON.universe', 'all'),
        selectedWatchlistCategory: get(action.searchObj, 'searchJSON.selectedWatchlistCategory', null),
        selectedSector: get(action.searchObj, 'searchJSON.sector', null),
        selectedIndustries: get(action.searchObj, 'searchJSON.industry_arr', []),
        isSimpleSearch: get(action.searchObj, 'searchJSON.isSimpleSearch', false),
        selectedCountry: get(action.searchObj, 'searchJSON.countryCode', null),
        simpleSearchTextArray: get(action.searchObj, 'searchJSON.simpleSearchTextArray', []),
        ignoreSearchTextArray: get(action.searchObj, 'searchJSON.ignoreSearchTextArray', []),
        selectedWatchlistCompanyNames: get(action.searchObj, 'searchJSON.company_arr', []),
        searchTextWithAnd: get(action.searchObj, 'searchJSON.searchTextWithAnd', []),
      };
    case RESET_ALL_SEARCH_PARAMS:
      return {
        ...state,
        ...searchDefaultState(),
      };
    case SET_SELECTED_SEARCH:
      return { ...state, selectedSearch: action.selectedSearch };
    case RESET_SUGGESTIONS:
      return { ...state, selectedSuggestions: {}, suggestions: {} };
    case SET_SUGGESTIONS_IS_LOADING:
      return { ...state, suggestionsIsLoading: action.suggestionsIsLoading };
    case SET_SHOW_BACKDROP:
      return { ...state, showBackdrop: action.showBackdrop ? state.showBackdrop + 1 : state.showBackdrop - 1 };
    case SET_SEARCH_RESULT_HIGHLIGHTS:
      return { ...state, searchResultHighlights: action.searchResultHighlights };
    case RESET_SEARCH_RESULTS:
      return {
        ...state,
        searchResultHighlights: null,
        searchResult: null,
        tweetsData: null,
        twitterTimelineChartData: null,
        twitterData: null,
        tweetsTableData: [],
        twitterMapData: [],
        twitterTopEntityContext: '',
      };
    case SET_SELECTED_COMPANY_NAME:
      return { ...state, selectedCompanyName: action.selectedCompanyName };
    case SET_SELECTED_UNIVERSE:
      return { ...state, selectedUniverse: action.selectedUniverse };
    case SET_SELECTED_SECTOR:
      return { ...state, selectedSector: action.selectedSector };
    case SET_SELECTED_WATCHLIST_CATEGORY:
      return { ...state, selectedWatchlistCategory: action.selectedWatchlistCategory };
    case SET_SELECTED_INDUSTRIES:
      return { ...state, selectedIndustries: action.selectedIndustries };
    case SET_SELECTED_WATCHLIST_COMPANY_NAMES:
      return { ...state, selectedWatchlistCompanyNames: action.selectedWatchlistCompanyNames };
    case SET_SAVED_SEARCHES:
      return { ...state, savedSearches: action.savedSearches };
    case SET_SEARCH_LABEL:
      return { ...state, searchLabel: action.searchLabel };
    case SET_OPEN_TOPIC_SEARCH_DIALOG:
      return { ...state, openTopicSearchDialog: action.openTopicSearchDialog };
    case SET_CURRENT_SEARCH_DETAIL:
      return { ...state, currentSearchDetail: action.currentSearchDetail };
    case SET_IS_TOPIC_EMAIL_ALERT_ENABLE:
      return { ...state, isTopicEmailAlertEnable: action.isTopicEmailAlertEnable };
    case SET_IS_SIMPLE_SEARCH:
      return { ...state, isSimpleSearch: action.isSimpleSearch };
    case SET_SIMPLE_SEARCH_TEXT_ARRAY:
      return { ...state, simpleSearchTextArray: action.simpleSearchTextArray };
    case SET_IGNORE_SEARCH_TEXT_ARRAY:
      return { ...state, ignoreSearchTextArray: action.ignoreSearchTextArray };
    case SET_SEARCH_TEXT_WITH_AND:
      return { ...state, searchTextWithAnd: action.searchTextWithAnd };
    case SET_SEARCH_INDEX:
      return { ...state, searchIndex: action.searchIndex };
    case SET_TWEETS_DATA:
      return { ...state, tweetsData: action.tweetsData };
    case SET_TWEETS_COUNTRY_MAP_DATA:
      return { ...state, tweetsCountryMapData: action.tweetsCountryMapData };
    case SET_TWEETS_TABLE_DATA:
      return { ...state, tweetsTableData: action.tweetsTableData };
    case SET_SELECTED_COUNTRY:
      return { ...state, selectedCountry: action.selectedCountry };
    case SET_TOPIC_SEARCH_COMPANY:
      return { ...state, topicSearchedComapny: action.topicSearchedComapny };
    case SET_SEARCH_SUGGESTION_TYPE:
      return { ...state, searchSuggestionType: action.searchSuggestionType };
    case SET_TWITTER_DATA:
      return { ...state, twitterData: action.twitterData };
    case SET_TWITTER_MAP_DATA:
      return { ...state, twitterMapData: action.twitterMapData };
    case SET_TWITTER_GEO_LOCATION_ENABLE:
      return { ...state, twitterGeoLocationEnable: action.twitterGeoLocationEnable };
    case SET_TWITTER_TIMELINE_CHART_DATA:
      return { ...state, twitterTimelineChartData: action.twitterTimelineChartData };
    case SET_TWITTER_ENTITY_CHART_DATA:
      return { ...state, twitterTopEntityGridData: action.twitterTopEntityGridData };
    case SET_TWITTER_TOP_ENTITY_CONTEXT:
      return { ...state, twitterTopEntityContext: action.twitterTopEntityContext };

    default:
      break;
  }
  return state;
}
